import React, { useEffect, useState } from "react";
import {
  Table,
  Space,
  Button,
  Typography,
  Tag,
  Descriptions,
  Drawer,
  Input,
  Row,
  Col,
  Select,
  Card,
  Switch,
  Popconfirm,
  notification,
  Image,
  DatePicker,
} from "antd";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  getAdmins,
  getOrders,
  getRslActivityLogs,
  getStatusList,
} from "../api/api";
import Spinner from "../components/Spinner";
import moment from "moment";
import { DollarOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import Status from "../components/Status";
import { isPermitted } from "../utils/PermissionManager";
import PhoneNumber from "../components/PhobeNumber";
import CustomerName from "../components/CustomerName";
import dayjs from "dayjs";

const { Column } = Table;
const { Option } = Select;
const { Text } = Typography;
const { Search } = Input;

export default function RslActivityLog() {
  const [filter, setFilter] = useState({});
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [admins, setAdmins] = useState(null);
  const [recalculate, setRecalculate] = useState(5);
  const history = useNavigate();

  useEffect(() => {
    setLoading(true);
    window.scrollTo({ top: 0 });
    let mFilter = filter ? { ...filter } : {};

    if (!filter.date) {
      mFilter.date = moment(new Date()).format("YYYY/MM/DD");
    }

    getRslActivityLogs((mData) => {
      setData(mData);
      setLoading(false);
    }, mFilter);
  }, [filter, recalculate]);

  useEffect(() => {
    let filter = { per_page: 1000 };
    getAdmins((data) => {
      setAdmins(data);
    }, filter);
  }, [recalculate]);

  function toTitleCase(str) {
    return str
      .replace(/_/g, " ") // replace underscores with spaces
      .replace(
        /\w\S*/g,
        (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
      );
  }

  return (
    <div>
      <Card style={{ marginBottom: ".5rem" }} size="small">
        <Row gutter={[16, 16]}>
          <Col md={{ span: 6 }}>
            <Text style={{ fontSize: "16px" }}>Order ID</Text>
            <Search
              placeholder="Order ID"
              onSearch={(value) => {
                setFilter({
                  order: value.trim(),
                });
              }}
              allowClear
              enterButton
              style={{
                width: "100%",
                marginTop: "0.5rem",
              }}
            />
          </Col>
          <Col md={{ span: 6 }}>
            <Text style={{ fontSize: "16px" }}>Select Admin</Text>
            <Select
              showSearch
              allowClear
              placeholder="Select Admin"
              style={{ width: "100%", marginTop: "0.5rem" }}
              onSelect={(val) => {
                setFilter({
                  admin: val,
                });
              }}
              onClear={() => {
                setFilter({});
              }}
              optionFilterProp="children"
            >
              {/* <Option key={1} value={null}>
                All
              </Option> */}
              {admins?.map((p, k) => (
                <Option key={p._id} value={p._id?.toString()}>
                  {p.name}
                </Option>
              ))}
            </Select>
          </Col>
          <Col md={{ span: 6 }}>
            <Text style={{ fontSize: "16px" }}>Select Action Type</Text>
            <Select
              style={{ width: "100%", marginTop: "0.5rem" }}
              placeholder="Filter by Type"
              onSelect={(val) => {
                setFilter({
                  type: val,
                });
              }}
              allowClear
              onClear={() => {
                setFilter({});
              }}
            >
              {[
                "item_update",
                "admin_discount",
                "percentage_charge",
                "shipping_method_change",
                "shipping_charge_change",
              ].map((el) => (
                <Option key={el} value={el}>
                  {toTitleCase(el)}
                </Option>
              ))}
            </Select>
          </Col>

          <Col md={{ span: 6 }}>
            <Text style={{ fontSize: "16px" }}>Select Date</Text>
            <DatePicker
              style={{ width: "100%", marginTop: "0.5rem" }}
              picker="date"
              defaultValue={dayjs(
                moment(new Date()).format("YYYY/MM/DD"),
                "YYYY/MM/DD"
              )}
              onChange={(e) => {
                setFilter({
                  date: moment(new Date(e)).format("YYYY/MM/DD"),
                });
              }}
            />
          </Col>
        </Row>
      </Card>
      {!loading && data && data.docs ? (
        <Table
          dataSource={data.docs}
          bordered
          rowKey={(record) => record._id}
          pagination={{
            current: filter && filter.page ? filter.page : 1,
            pageSize: data.limit,
            total: data.totalDocs,
            showSizeChanger: false,
          }}
          onChange={(page, pageSize) => {
            setFilter({ ...filter, page: page.current });
          }}
        >
          <Column
            title="Date"
            dataIndex="date"
            render={(text, record, index) => (
              <div style={{ fontSize: "13px" }}>
                <p>{moment(new Date(record.time)).format("DD/MM/YYYY")}</p>
                <p>{moment(new Date(record.time)).format("hh:mm A")}</p>
              </div>
            )}
          />
          <Column
            title="Action Type"
            dataIndex="id"
            key="id"
            render={(text, record, index) => (
              <div>
                <Status name={toTitleCase(record.type)} />
              </div>
            )}
          />

          <Column
            title="Order"
            dataIndex="id"
            key="id"
            render={(text, record, index) => (
              <div style={{ textTransform: "uppercase" }}>
                <Link
                  to={`https://shahil.skybuybd.com/order/${record.order?.code}`}
                  target="_blank"
                >
                  <Status name={record.order?.code} />
                </Link>
              </div>
            )}
          />
          <Column
            title="Admin"
            dataIndex="user"
            render={(text, record, index) => (
              <>
                <div>{record.admin?.name}</div>
              </>
            )}
          />

          <Column
            title="Item"
            key="sub_total"
            render={(text, record) => (
              <div>
                {record.item && (
                  <>
                    {Object.entries(record.item).map(([key, value]) => (
                      <div key={key}>
                        <strong>{toTitleCase(key)}:</strong> {value}
                      </div>
                    ))}
                  </>
                )}
              </div>
            )}
          />
          <Column
            title="Old Data"
            key="sub_total"
            render={(text, record) => (
              <div>
                {record.oldData && (
                  <>
                    {Object.entries(record.oldData).map(([key, value]) => (
                      <div key={key}>
                        <strong>{toTitleCase(key)}:</strong> {value}
                      </div>
                    ))}
                  </>
                )}
              </div>
            )}
          />
          <Column
            title="New Data"
            key="grand_total"
            render={(text, record) => (
              <div>
                {record.newData && (
                  <>
                    {Object.entries(record.newData).map(([key, value]) => (
                      <div key={key}>
                        <strong>{toTitleCase(key)}:</strong> {value}
                      </div>
                    ))}
                  </>
                )}
              </div>
            )}
          />
        </Table>
      ) : (
        <div>
          <Spinner />
        </div>
      )}
    </div>
  );
}
